import { useState, useEffect, useRef, useMemo, useForm } from 'react';
import { Tooltip, IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { TimeField } from '@mui/x-date-pickers/TimeField';
import './allocation.css';
import { customerbasedshift, shiftadd, Deviceattributeget, cleanCustomerId, Downtimeadd2 } from '../../Services/app/masterservice';
import { customerbaseddevices, telemetrylatestdata } from '../../Services/app/andondashboardservice';
import {
  Downtimeadd1, DowntimeaddDelete

} from '../../Services/app/masterservice';

import Swal from 'sweetalert2';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import 'react-time-picker/dist/TimePicker.css';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import { MobileTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import PersonIcon from '@mui/icons-material/Person';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import SettingsIcon from '@mui/icons-material/Settings';
import { Columns } from 'lucide-react';
import { CustomDateSelect, CustomDaySelect } from '../Inputfield/inputfield';
import { telemetrykeydata } from '../../Services/app/andondashboardservice';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import { DesktopTimePicker } from '@mui/x-date-pickers/DesktopTimePicker';
// Function to convert seconds to HH:mm:ss format
import VisibilityIcon from '@mui/icons-material/Visibility'; // 👁️ icon from MUI
import { useNavigate } from 'react-router-dom';

const formatSecondsToTime = (seconds) => {
  if (!seconds || isNaN(seconds)) return 'Not set';
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};

const Allocation = () => {
  // Dialog state
  const [selectedShift, setSelectedShift] = useState('');
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [editDialogData, setEditDialogData] = useState(null);
  const [dialogOpenCount, setDialogOpenCount] = useState(0);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [openEditDialog1, setOpenEditDialog1] = useState(false);
  const [openEditDialog2, setOpenEditDialog2] = useState(false);
  const [OpenEditDialog4, setOpenEditDialog4] = useState(false);
  const [selectedDevicename, setSelectedDevicename] = useState(null);
  const [selectedDeviceId, setSelectedDeviceId] = useState(null);
  const [operatorselected, setselectedoperator] = useState('');
  const [reasonselected, setselectedreason] = useState('');
  const [componentselected, setselectedcomponent] = useState('');
  const customerId = localStorage.getItem('CustomerID');
  const [devices, setDevices] = useState([]);
  const [operators, setoperators] = useState([]);
  const [operatorslist, setoperatorslist] = useState([]);
  const [reasons, setreasons] = useState([]);
  const [reasonslist, setreasonslist] = useState([]);
  const [components, setcomponents] = useState([]);
  const [componentslist, setcomponentslist] = useState([]);
  const [deviceThresholds, setDeviceThresholds] = useState({});
  const [shiftOptions, setShiftOptions] = useState([]);
  const [shifts, setShifts] = useState([]);
  const [downtimedata, setDowntimeData] = useState([]);
  const [epochRange, setEpochRange] = useState({ from: null, to: null });
  const [loading, setLoading] = useState(false);
  const [filteredResult, setfilteredResult] = useState([]); // Changed from {} to []
  const [operatorsByDevice, setOperatorsByDevice] = useState({});
  const [componentsByDevice, setComponentsByDevice] = useState({});
  const [reasonsByDevice, setReasonsByDevice] = useState({});
  const [supervisors, setsupervisors] = useState([]);
  const [supervisorslist, setsupervisorslist] = useState([]);
  const [supervisorsByDevice, setSupervisorByDevice] = useState([]); const [supervisorselected, setselectedsupervisor] = useState('');
  const [mismatchOpen, setMismatchOpen] = useState(false);
  const [mismatchLoading, setMismatchLoading] = useState(false);
  const [mismatchEvents, setMismatchEvents] = useState([]);
  const [liveMismatches, setLiveMismatches] = useState([]);
  const [autoSuggestStatus, setAutoSuggestStatus] = useState(null);
  const [autoSuggestLoading, setAutoSuggestLoading] = useState(false);
  const [mismatchSort, setMismatchSort] = useState({ col: 'machining_variance_pct', dir: 'desc' });
  const [mismatchShiftStartIst, setMismatchShiftStartIst] = useState(null);
  const [mismatchSkipped, setMismatchSkipped] = useState([]);
  const customDaySelectRef = useRef();
  const selectRef = useRef();

  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);

  const navigate = useNavigate();

  const handleViewClick = (id, name) => {
    const deviceId = id;
    navigate(`/operator-details?deviceId=${deviceId}&deviceName=${name}`); // Navigate to operator details page
  };
  const handleViewClick1 = (id, name) => {
    const deviceId = id;
    // navigate(`/operator-details?deviceId=${deviceId}&deviceName=${name}`); // Navigate to operator details page
  };
  // Helper function to get epoch from shift
  const getEpochFromShift = (shiftNo, selectedDateObj) => {
    if (!shiftNo || !selectedDateObj || shifts.length === 0) {
      return { fromEpoch: null, toEpoch: null };
    }

    const selectedShiftData = shifts.find(shift => shift.shift_no === shiftNo);
    if (!selectedShiftData) {
      return { fromEpoch: null, toEpoch: null };
    }

    const dateStr = selectedDateObj.format('YYYY-MM-DD');
    const startDateTime = dayjs(`${dateStr}T${selectedShiftData.start_time}`);

    let endDateTime;
    // If shift 2, assume overnight so add 1 day to end time
    if (String(shiftNo) === "2" || shiftNo === 2) {
      const nextDay = selectedDateObj.add(1, 'day').format('YYYY-MM-DD');
      endDateTime = dayjs(`${nextDay}T${selectedShiftData.end_time}`);
    } else {
      endDateTime = dayjs(`${dateStr}T${selectedShiftData.end_time}`);
    }

    return {
      fromEpoch: startDateTime.valueOf(),
      toEpoch: endDateTime.valueOf()
    };
  };

  const isTimeInShift = (time, shift) => {
    if (!shift) return true;
    const start = dayjs(shift.start_time, 'HH:mm:ss');
    const end = dayjs(shift.end_time, 'HH:mm:ss');
    // Overnight shift
    if (end.isBefore(start)) {
      return time.isAfter(start) || time.isBefore(end) || time.isSame(start) || time.isSame(end);
    }
    // Normal shift
    return (time.isAfter(start) && time.isBefore(end)) || time.isSame(start) || time.isSame(end);
  };
  const handleStartTimeChange = async (value) => {
    if (!value || !isTimeInShift(value, selectedShiftData)) {
      Swal.fire('Error', 'Selected time is outside the shift range!', 'error');
      return;
    }

    setStartTime(value);

    if (endTime) {
      await validateAndCheckOverlap(value, endTime);
    }
  };
  const validateAndCheckOverlap = async (newStart, newEnd) => {
    if (!selectedDate || !selectedDeviceId?.id) return;

    const fromEpoch = dayjs(selectedDate).hour(newStart.hour()).minute(newStart.minute()).second(newStart.second()).valueOf();
    const toEpoch = dayjs(selectedDate).hour(newEnd.hour()).minute(newEnd.minute()).second(newEnd.second()).valueOf();

    // Ensure start time is before end time
    if (fromEpoch >= toEpoch) {
      Swal.fire('Error', 'Start time must be before end time.', 'error');
      setStartTime(null);
      setEndTime(null);
      return;
    }

    const hasOverlap = await checkOperatorTimeOverlap(selectedDeviceId.id, fromEpoch, toEpoch);

    if (hasOverlap) {
      Swal.fire('Error', 'Selected time overlaps with an already assigned operator.', 'error');
      setStartTime(null);
      setEndTime(null);
    }
  };
  const checkOperatorTimeOverlap = async (deviceId, fromEpoch, toEpoch) => {
    try {
      // Get all existing operator assignments for this device, not just within the new time range
      const response = await telemetrykeydata(deviceId, 'DEVICE', 'live_operator', 0, Date.now());

      const existingData = response?.live_operator || [];

      for (const item of existingData) {
        if (!item?.value) continue;

        let parsed = {};
        try {
          parsed = JSON.parse(item.value);
        } catch (e) {
          continue;
        }

        const existingStart = parsed.operator_start_time || item.ts;
        const existingEnd = parsed.oprator_end_time || (existingStart + (parsed.operator_duration || 0) * 1000);

        // Check overlap: if the new time range overlaps with any existing assignment
        const isOverlapping = fromEpoch < existingEnd && existingStart < toEpoch;
        if (isOverlapping) {
          console.log('Overlap detected:', {
            newStart: new Date(fromEpoch),
            newEnd: new Date(toEpoch),
            existingStart: new Date(existingStart),
            existingEnd: new Date(existingEnd),
            operator: parsed.operator
          });
          return true; // Conflict found
        }
      }

      return false; // No conflicts
    } catch (error) {
      console.error('Error checking overlap:', error);
      return false;
    }
  };

  const handleEndTimeChange = async (value) => {
    if (!value || !isTimeInShift(value, selectedShiftData)) {
      Swal.fire('Error', 'Selected time is outside the shift range!', 'error');
      return;
    }

    setEndTime(value);

    if (startTime) {
      await validateAndCheckOverlap(startTime, value);
    }
  };

  const handleShiftChange = (shiftValue) => {
    setSelectedShift(shiftValue);
    setSelectedShift(shiftValue);
    const selectedShiftData = shifts.find(shift => shift.shift_no === shiftValue);
    if (selectedShiftData) {
      setStartTime(dayjs(selectedShiftData.start_time, 'HH:mm:ss'));
      setEndTime(dayjs(selectedShiftData.end_time, 'HH:mm:ss'));
    }
    const { fromEpoch, toEpoch } = getEpochFromShift(shiftValue, selectedDate);
    setEpochRange({ from: fromEpoch, to: toEpoch });
  };
  const operatorvaluechange = (shiftValue) => {
    setSelectedShift(shiftValue);
    const { fromEpoch, toEpoch } = getEpochFromShift(shiftValue, selectedDate);
    setEpochRange({ from: fromEpoch, to: toEpoch });
    const key = 'alloperator';
    customerbasedshift(customerId, key)
      .then(async (data) => {
        const allShifts = data[0]?.value || [];
        setoperatorslist(allShifts);
        console.log('alloperator', allShifts);

        // ✅ Filter only "Operator" mode
        const operatorNames = allShifts
          .filter(shift => shift.mode === "Operator")  // <-- filter added
          .map(shift => ({
            value: shift.operatorname,
            label: shift.operatorname
          }));

        setoperators(operatorNames);
        const key2 = 'live_operator';
        const entitytype = 'DEVICE';
        const deviceid = selectedDeviceId;

        try {
          const response = await telemetrykeydata(deviceid, entitytype, key2, fromEpoch, toEpoch);
          //const response = await telemetrylatestdata(deviceid, entitytype, key2);
          if (response && response.live_operator && response.live_operator.length > 0 && response.live_operator[0].value) {
            let operator = JSON.parse(response.live_operator[0].value).operator;
            setselectedoperator(operator);
          } else {
            setselectedoperator('');
          }
        } catch (error) {

          setselectedoperator('');
        }
        setOpenEditDialog(true);
      })
      .catch(error => {
        console.error("Error fetching shifts:", error);
      });
  };
  const handleReasonChange = (index, val) => {
    setfilteredResult(prevResults => {
      const updatedResults = [...prevResults];
      updatedResults[index] = {
        ...updatedResults[index],
        reasonselected: val
      };
      return updatedResults;
    });
  };
  // Handle date change: update selectedDate and recalculate epochRange
  const handleDateChange = (newValue) => {
    const dayjsVal = dayjs(newValue);
    setSelectedDate(dayjsVal);

    // Recalculate epoch range when date changes
    if (selectedShift && shifts.length > 0) {
      const { fromEpoch, toEpoch } = getEpochFromShift(selectedShift, dayjsVal);
      setEpochRange({ from: fromEpoch, to: toEpoch });
      const key = 'alloperator';
      customerbasedshift(customerId, key)
        .then(async (data) => {
          const allShifts = data[0]?.value || [];
          setoperatorslist(allShifts);
          console.log('alloperator', allShifts);

          // ✅ Filter only "Operator" mode
          const operatorNames = allShifts
            .filter(shift => shift.mode === "Operator")  // <-- filter added
            .map(shift => ({
              value: shift.operatorname,
              label: shift.operatorname
            }));

          setoperators(operatorNames);
          const key2 = 'live_operator';
          const entitytype = 'DEVICE';
          const deviceid = selectedDeviceId;

          try {
            const response = await telemetrykeydata(deviceid, entitytype, key2, fromEpoch, toEpoch);
            //const response = await telemetrylatestdata(deviceid, entitytype, key2);
            if (response && response.live_operator && response.live_operator.length > 0 && response.live_operator[0].value) {
              let operator = JSON.parse(response.live_operator[0].value).operator;
              setselectedoperator(operator);
            } else {
              setselectedoperator('');
            }
          } catch (error) {

            setselectedoperator('');
          }
          //setOpenEditDialog(true);
        })
        .catch(error => {
          console.error("Error fetching shifts:", error);
        });
    }
  };
  const handleDateChange1 = (newValue) => {
    const dayjsVal = dayjs(newValue);
    setSelectedDate(dayjsVal);

    // Recalculate epoch range when date changes
    if (selectedShift && shifts.length > 0) {
      const { fromEpoch, toEpoch } = getEpochFromShift(selectedShift, dayjsVal);
      setEpochRange({ from: fromEpoch, to: toEpoch });
      const key = 'alloperator';
      customerbasedshift(customerId, key)
        .then(async (data) => {
          const allShifts = data[0]?.value || [];
          setoperatorslist(allShifts);
          console.log('alloperator', allShifts);

          // ✅ Filter only "Operator" mode
          const operatorNames = allShifts
            .filter(shift => shift.mode === "Operator")  // <-- filter added
            .map(shift => ({
              value: shift.operatorname,
              label: shift.operatorname
            }));

          setoperators(operatorNames);
          const key2 = 'live_operator';
          const entitytype = 'DEVICE';
          const deviceid = selectedDeviceId;

          try {
            const response = await telemetrykeydata(deviceid, entitytype, key2, fromEpoch, toEpoch);
            //const response = await telemetrylatestdata(deviceid, entitytype, key2);
            if (response && response.live_operator && response.live_operator.length > 0 && response.live_operator[0].value) {
              let operator = JSON.parse(response.live_operator[0].value).operator;
              setselectedoperator(operator);
            } else {
              setselectedoperator('');
            }
          } catch (error) {

            setselectedoperator('');
          }
        })
        .catch(error => {
          console.error("Error fetching shifts:", error);
        });
    }
  };
  const getEpochFromShift1 = (shiftNo, selectedDateObj, shiftsList) => {
    if (!shiftNo || !selectedDateObj || shiftsList.length === 0) {
      return { fromEpoch: null, toEpoch: null };
    }

    const selectedShiftData = shiftsList.find(shift => shift.shift_no === shiftNo);
    if (!selectedShiftData) {
      return { fromEpoch: null, toEpoch: null };
    }

    const dateStr = selectedDateObj.format('YYYY-MM-DD');
    const startDateTime = dayjs(`${dateStr}T${selectedShiftData.start_time}`);

    let endDateTime;
    if (String(shiftNo) === "2" || shiftNo === 2) {
      const nextDay = selectedDateObj.add(1, 'day').format('YYYY-MM-DD');
      endDateTime = dayjs(`${nextDay}T${selectedShiftData.end_time}`);
    } else {
      endDateTime = dayjs(`${dateStr}T${selectedShiftData.end_time}`);
    }

    if (String(shiftNo) !== "2" && shiftNo !== 2) {
      const todayStr = dayjs().format('YYYY-MM-DD');
      if (dateStr === todayStr) {
        const now = dayjs();
        if (now.isBefore(endDateTime)) {
          endDateTime = now;
        }
      }
    }

    return {
      fromEpoch: startDateTime.valueOf(),
      toEpoch: endDateTime.valueOf()
    };
  };

  const handleOperatorChange = (newValue) => {
    const dayjsVal = dayjs(newValue);
    setSelectedDate(dayjsVal);

    // Recalculate epoch range when date changes
    if (selectedShift && shifts.length > 0) {
      const { fromEpoch, toEpoch } = getEpochFromShift(selectedShift, dayjsVal);
      setEpochRange({ from: fromEpoch, to: toEpoch });
    }
  };

  const handleFormChange = (event) => {
    const { name, value } = event.target;
    setselectedoperator(value);
  };
  const handleFormChange1 = (event) => {
    const { name, value } = event.target;
    setselectedreason(value);
  };
  const handleFormChange2 = (event) => {
    const { name, value } = event.target;
    setselectedcomponent(value);
  };
  const handleFormChange3 = (event) => {
    const { name, value } = event.target;
    setselectedsupervisor(value);
  };
  const handleOpenEditDialog = async (rowData) => {
    setLoading(true);
    const key1 = 'allShift';

    try {
      const shiftData = await customerbasedshift(customerId, key1);
      const allShifts = shiftData[0]?.value || [];
      setShifts(allShifts);

      const options = allShifts.map((shift) => ({
        value: shift.shift_no,
        label: `Shift${shift.shift_no}`,
      }));
      setShiftOptions(options);

      if (options.length > 0) {
        const defaultShift = options[0].value;
        setSelectedDate(dayjs()); // Set to current date
        setSelectedShift(defaultShift);
        setfilteredResult([]); // (Optional) clear table

        // Calculate initial epoch range for current date and first shift
        const { fromEpoch, toEpoch } = getEpochFromShift(defaultShift, dayjs());
        setEpochRange({ from: fromEpoch, to: toEpoch });
        console.log('fromEpoch:', fromEpoch, 'toEpoch:', toEpoch, 'defaultShift:', defaultShift, 'currentDate:', dayjs());

        setfilteredResult([]);

        // Get operator data
        const key = 'alloperator';
        const operatorData = await customerbasedshift(customerId, key);
        const allOperators = operatorData[0]?.value || [];
        setoperatorslist(allOperators);

        const operatorNames = allOperators
          .filter((shift) => shift.mode === "Operator")
          .map((shift) => ({
            value: shift.operatorname,
            label: shift.operatorname
          }));
        setoperators(operatorNames);

        // ✅ Now safely fetch live_operator after all data is ready
        const deviceid = rowData.id?.id || rowData.id;
        setSelectedDeviceId(deviceid);
        setSelectedDevicename(rowData.name);
        const key2 = 'live_operator';
        const entitytype = 'DEVICE';

        await fetchLiveOperator(deviceid, entitytype, key2, fromEpoch, toEpoch);

        // Clear time fields for fresh start
        setStartTime(null);
        setEndTime(null);

        setOpenEditDialog(true);
      }
    } catch (err) {
      console.error('Error in handleOpenEditDialog:', err);
    } finally {
      setLoading(false);
    }
  };

  const fetchLiveOperator = async (deviceid, entitytype, key2, fromEpoch, toEpoch) => {
    try {
      const response = await telemetrykeydata(deviceid, entitytype, key2, fromEpoch, toEpoch);
      if (
        response &&
        response.live_operator &&
        response.live_operator.length > 0 &&
        response.live_operator[0].value
      ) {
        const operator = JSON.parse(response.live_operator[0].value).operator;
        setselectedoperator(operator);
      } else {
        setselectedoperator('');
      }
    } catch (error) {
      console.error('Error fetching live_operator:', error);
      setselectedoperator('');
    }
  };


  const handleOpenEditDialog1 = async (rowData) => {
    const key = 'reason';
    const customerId = localStorage.getItem('CustomerID');
    customerbasedshift(customerId, key)
      .then(async (data) => {
        const allShifts = data[0]?.value || [];
        setreasonslist(allShifts);
        const reasons = allShifts.map(shift => ({
          value: shift.reason,
          label: shift.reason
        }));
        setreasons(reasons);
        setSelectedDeviceId(rowData.id?.$oid || rowData.id);
        setOpenEditDialog1(true);
        //downtimereason();
      })
      .catch(error => {
        console.error("Error fetching shifts:", error);
      });
    const key1 = 'allShift';

    // Fetch shifts and set shift options
    customerbasedshift(customerId, key1)
      .then(async (data) => {
        const allShifts = data[0].value || [];
        setShifts(allShifts);

        const options = allShifts.map((shift) => ({
          value: shift.shift_no,
          label: `Shift${shift.shift_no}`,
        }));
        setShiftOptions(options);

        if (options.length > 0) {
          const defaultShift = options[0].value;
          setSelectedDate(dayjs()); // Set to current date
          setSelectedShift(defaultShift);
          setfilteredResult([]); // (Optional) clear table

          // Calculate initial epoch range for current date and first shift
          const { fromEpoch, toEpoch } = getEpochFromShift(defaultShift, dayjs());
          setEpochRange({ from: fromEpoch, to: toEpoch });
        }
      })
      .catch((err) => {
        console.error('Error loading shifts:', err);
      })
      .finally(() => setLoading(false));
  };
  const handleOpenEditDialog2 = async (rowData) => {
    const key = 'component';
    customerbasedshift(customerId, key)
      .then(async (data) => {
        const allShifts = data[0]?.value || [];
        setcomponentslist(allShifts);
        console.log('allshifts', allShifts)
        const reasons = allShifts.map(shift => ({
          value: shift.component_name,
          label: shift.component_name
        }));
        setcomponents(reasons);
        setSelectedDeviceId(rowData.id?.$oid || rowData.id);
        const key2 = 'live_component';
        const entitytype = 'DEVICE';
        const deviceid = rowData.id.id;

        try {
          const response = await telemetrylatestdata(deviceid, entitytype, key2);
          if (response && response.live_component && response.live_component.length > 0 && response.live_component[0].value) {
            let operator = JSON.parse(response.live_component[0].value).component_name;
            setselectedcomponent(operator);
          } else {
            setselectedoperator('');
          }
        } catch (error) {
          setselectedoperator('');
        }
        setOpenEditDialog2(true);
      })
      .catch(error => {
        console.error("Error fetching shifts:", error);
      });
  };
  const handleSaveThreshold = async () => {
    try {
      if (!selectedDeviceId || !selectedShift || !selectedDate || !operatorselected) {
        Swal.fire('Error', 'Please fill all required fields.', 'error');
        return;
      }

      let fromEpoch, toEpoch;

      if (startTime && endTime && selectedDate) {
        const start = dayjs(selectedDate)
          .set('hour', startTime.hour())
          .set('minute', startTime.minute())
          .set('second', startTime.second())
          .set('millisecond', 0);

        let end;

        // Overnight shift: end time is earlier than start time
        if (endTime.isBefore(startTime)) {
          end = dayjs(selectedDate)
            .add(1, 'day')
            .set('hour', endTime.hour())
            .set('minute', endTime.minute())
            .set('second', endTime.second())
            .set('millisecond', 0);
        } else {
          // Same-day shift
          end = dayjs(selectedDate)
            .set('hour', endTime.hour())
            .set('minute', endTime.minute())
            .set('second', endTime.second())
            .set('millisecond', 0);
        }

        fromEpoch = start.valueOf();
        toEpoch = end.valueOf();
      }
      else {
        const shiftEpoch = getEpochFromShift(selectedShift, selectedDate);
        fromEpoch = shiftEpoch.fromEpoch;
        toEpoch = shiftEpoch.toEpoch;
      }

      if (!fromEpoch || !toEpoch) return;
      const shiftEpoch = getEpochFromShift(selectedShift, selectedDate);
      let fromtime = shiftEpoch.fromEpoch;
      let totime = shiftEpoch.toEpoch;
      let durations = Math.floor((toEpoch - fromEpoch) / 1000);

      // 🔍 Check for overlap before saving
      const response = await telemetrykeydata(
        selectedDeviceId,
        'DEVICE',
        'live_operator',
        fromtime,
        totime
      );

      const existingEntries = response?.live_operator || [];
      console.log('existingdatas', existingEntries)
      for (const item of existingEntries) {
        if (!item?.value) continue;

        let parsed;
        try {
          parsed = JSON.parse(item.value);
        } catch (e) {
          continue;
        }

        const existingStart = parsed.operator_start_time || item.ts;
        const existingEnd =
          parsed.oprator_end_time ||
          (existingStart + (parsed.operator_duration || 0) * 1000);

        const isOverlapping = fromEpoch < existingEnd && existingStart < toEpoch;

        if (isOverlapping) {
          const existingOperator = parsed.operator || 'Unknown';
          const conflictStart = dayjs(existingStart).format('DD-MM-YYYY HH:mm:ss');
          const conflictEnd = dayjs(existingEnd).format('DD-MM-YYYY HH:mm:ss');

          Swal.fire({
            icon: 'error',
            title: 'Error',
            html: `Time overlaps with existing operator "<strong>${existingOperator}</strong>" between <strong>${conflictStart}</strong> and <strong>${conflictEnd}</strong>.`,
            showCancelButton: true,
            confirmButtonText: 'Overwrite',
            cancelButtonText: 'No, Cancel',
            backdrop: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false
          }).then((result1) => {
            if (result1.isConfirmed) {
              // Only show the second confirmation if user clicked "Overwrite"
              Swal.fire({
                title: 'Do you want to overwrite the existing operator allocation with the new changes?',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Yes, Save',
                cancelButtonText: 'No, Cancel',
                backdrop: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false
              }).then(async (result2) => {
                if (result2.isConfirmed) {
                  try {
                    // First delete existing data in the time range
                    const deleteResponse = await DowntimeaddDelete('DEVICE', selectedDeviceId, 'live_operator', fromEpoch, toEpoch);

                    if (deleteResponse !== true) {
                      throw new Error('Failed to delete existing data for the specified time range.');
                    }
                    else {
                      const operator = operatorslist.find(op => op.operatorname === operatorselected);
                      const opertorid = operator ? operator.operatorid : null;

                      const key = {
                        ts: fromEpoch,
                        values: {
                          live_operator: {
                            operator: operatorselected,
                            code: opertorid,
                            operator_start_time: fromEpoch,
                            oprator_end_time: toEpoch,
                            operator_duration: durations
                          }
                        }
                      };

                      await Downtimeadd1('DEVICE', selectedDeviceId, 'SERVER_SCOPE', key);

                      setDeviceThresholds(prev => ({
                        ...prev,
                        [selectedDeviceId.id || selectedDeviceId]: operatorselected
                      }));

                      Swal.fire({
                        title: 'Success',
                        text: 'Operator assigned successfully.',
                        icon: 'success',
                        backdrop: true,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: false
                      });
                      setTimeout(() => {
                        getShifts();
                      }, 2000);
                    }
                    // Then proceed to add new operator data

                  } catch (error) {
                    console.error('Error in operator allocation update:', error);
                    Swal.fire({
                      title: 'Error',
                      text: error.message || 'Failed to update operator allocation.',
                      icon: 'error',
                      backdrop: true,
                      allowOutsideClick: false,
                      allowEscapeKey: false,
                      allowEnterKey: false
                    });
                  }
                } else {
                  console.log("User cancelled save.");
                }
              });
            } else {
              console.log("User cancelled overwrite.");
            }
          });


          return;
        }
      }

      // ✅ Proceed to save if no overlap
      const operator = operatorslist.find(op => op.operatorname === operatorselected);
      const opertorid = operator ? operator.operatorid : null;

      const key = {
        ts: fromEpoch,
        values: {
          live_operator: {
            operator: operatorselected,
            code: opertorid,
            operator_start_time: fromEpoch,
            oprator_end_time: toEpoch,
            operator_duration: durations
          }
        }
      };

      await Downtimeadd1('DEVICE', selectedDeviceId, 'SERVER_SCOPE', key);

      setDeviceThresholds(prev => ({
        ...prev,
        [selectedDeviceId.id || selectedDeviceId]: operatorselected
      }));

      Swal.fire('Success', 'Operator assigned successfully.', 'success');
      setTimeout(() => {
        getShifts();
      }, 2000);
    } catch (err) {
      console.error('Update error:', err);
      Swal.fire('Error', 'Failed to assign operator.', 'error');
    } finally {
      setOpenEditDialog(false);
    }
  };


  const handleSaveThreshold1 = async () => {
    try {
      const completedRows = filteredResult.filter(item => item.reasonselected);

      if (completedRows.length === 0) {
        Swal.fire('Warning', 'No reasons selected to save.', 'warning');
        return;
      }

      for (const item of completedRows) {
        const operator = reasonslist.find(op => op.reason === item.reasonselected);
        const code = operator ? operator.code : null;
        const mode = operator ? operator.mode : null;
        const category = operator ? operator.category : null;

        const key = {
          ts: item.start,  // This becomes the top-level "ts" field
          values: {
            live_reason: {
              name: item.reasonselected,
              code: code,
              mode: mode,
              category: category,
              idle_start: item.start,
              idle_end: item.end,
              idle_duration: item.duration
              // idle_start can be same as item.start or adjusted as needed

            }
          }
        };


        await Downtimeadd1('DEVICE', selectedDeviceId.id, 'SERVER_SCOPE', key);

        // Optional: Update UI state to reflect change
        setDeviceThresholds(prev => ({
          ...prev,
          [selectedDeviceId.id || selectedDeviceId]: item.reasonselected
        }));
      }

      Swal.fire('Success', 'Reasons assigned successfully.', 'success');
      setTimeout(() => {
        getShifts();
      }, 2000);
    } catch (err) {
      console.error('Update error:', err);
      Swal.fire('Error', 'Failed to assign reason.', 'error');
    } finally {
      setOpenEditDialog1(false);
    }
  };

  // Parses "HH:MM:SS" / "MM:SS" / number to seconds. 0 on bad input.
  const parseHmsToSec = (s) => {
    if (s == null) return 0;
    if (typeof s === 'number') return s;
    const m = String(s).match(/^(\d{1,3}):(\d{1,2}):(\d{1,2})$/);
    if (m) return Number(m[1]) * 3600 + Number(m[2]) * 60 + Number(m[3]);
    const m2 = String(s).match(/^(\d{1,3}):(\d{1,2})$/);
    if (m2) return Number(m2[1]) * 60 + Number(m2[2]);
    return Number(s) || 0;
  };
  const fmtMinSec = (sec) => {
    if (!sec || isNaN(sec)) return '-';
    const m = Math.floor(sec / 60);
    const s = Math.round(sec % 60);
    return m > 0 ? `${m}m ${s}s` : `${s}s`;
  };

  // Match by MACHINING TIME ONLY — machining is program-specific (depends on
  // G-code, feed rate, RPM) and operator-independent, so it's the right signal
  // for "which component/program is running". Handling time varies by operator
  // and shouldn't influence the match.
  const findSuggestedComponent = (observedMachiningMin) => {
    if (!componentslist?.length || !observedMachiningMin || observedMachiningMin <= 0) return null;
    let best = null;
    let bestMachMin = 0;
    let bestDiff = Infinity;
    for (const c of componentslist) {
      const machSec = parseHmsToSec(c.cycle_time);
      if (!machSec) continue;
      const machMin = machSec / 60;
      const diff = Math.abs(machMin - observedMachiningMin);
      if (diff < bestDiff) {
        bestDiff = diff;
        best = c;
        bestMachMin = machMin;
      }
    }
    if (!best) return null;
    const variance = Math.abs(bestMachMin - observedMachiningMin) / observedMachiningMin;
    if (variance > 0.20) return null;
    return {
      component: best,
      machining_min: Math.round(bestMachMin * 10) / 10,
      variance_pct: Math.round(variance * 100),
    };
  };

  // One-click "Assign this" from the mismatch panel — sets the device's
  // live_component to the suggested component using the same SERVER_SCOPE
  // attribute write the Allocations save path uses.
  const assignSuggestedFromPanel = async (deviceId, deviceName, component) => {
    const confirm = await Swal.fire({
      title: `Assign to ${deviceName}?`,
      html: `<div style="text-align:left;font-size:14px">
        Set <b>${deviceName}</b>'s live component to <b>${component.component_name}</b>?<br/><br/>
        <span style="color:#6b7280;font-size:12px">This updates the live_component attribute so the screens reflect what's actually running on the machine.</span>
      </div>`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, Assign',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#ec6e17',
      cancelButtonColor: '#6b7280',
      reverseButtons: true,
    });
    if (!confirm.isConfirmed) return;
    try {
      const isGplast = cleanCustomerId(customerId) === window._env_.GPLAST_CUSTOMER_ID;
      const key2 = {
        component_name: component.component_name,
        component_id: component.component_number,
        cycle_time: component.cycle_time,
        handling_time: component.handling_time,
        setup_time: component.setupTime,
        component_start_time: Date.now(),
        ...(isGplast && {
          item_code: component.item_code,
          process_name: component.process_name,
        }),
      };
      const key = {
        live_component: JSON.stringify(key2),
        lastUpdateTs: Date.now(),
      };
      await Downtimeadd1('DEVICE', deviceId, 'SERVER_SCOPE', key);
      Swal.fire({
        title: 'Assigned',
        text: `${component.component_name} is now the live component for ${deviceName}.`,
        icon: 'success',
        timer: 2000,
        showConfirmButton: false,
      });
      setTimeout(() => openMismatchPanel(), 800);
    } catch (e) {
      console.error('assign suggested failed', e);
      Swal.fire('Error', 'Failed to assign component.', 'error');
    }
  };

  // Auto-Assign: one-click action — ask backend what cycle this machine is
  // actually running this shift, find the closest component in master by
  // machining time, then confirm and assign (writes live_component directly).
  // Saves the supervisor from manually picking from the dropdown.
  const handleAutoSuggest = async () => {
    if (!selectedDeviceId?.id) {
      Swal.fire('No machine selected', 'Select a machine first.', 'info');
      return;
    }
    setAutoSuggestLoading(true);
    setAutoSuggestStatus(null);
    try {
      const base = (window._env_?.SERVER_URL2 || '').replace(/\/$/, '');
      const resp = await fetch(
        `${base}/api/operator-assignment/observed-cycle?device_id=${encodeURIComponent(selectedDeviceId.id)}`,
      );
      if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
      const j = await resp.json();
      if (j?.non_production_reason) {
        setAutoSuggestStatus({
          ok: false,
          message: `Machine is not in active production: ${j.non_production_reason}. Auto-assign skipped — observed cycle wouldn't reflect real production.`,
        });
        return;
      }
      const observedMach = j?.observed_machining_min;
      if (!observedMach || observedMach <= 0 || (j?.samples ?? 0) < 5) {
        setAutoSuggestStatus({
          ok: false,
          message: `Not enough machining data this shift (${j?.samples ?? 0} samples, ${j?.parts_produced ?? 0} parts produced). Try again after a few more parts.`,
        });
        return;
      }
      const sug = findSuggestedComponent(observedMach);
      if (!sug) {
        setAutoSuggestStatus({
          ok: false,
          message: `Machine's machining time is ~${observedMach}m this shift (${j?.parts_produced ?? 0} parts produced), but no component in master matches (within 20%). Update master or add a new component.`,
        });
        return;
      }

      const machineName = selectedDeviceId?.name || 'this machine';
      const confirm = await Swal.fire({
        title: 'Auto-Assign Best Match?',
        html: `<div style="text-align:left;font-size:14px;line-height:1.5">
          <div style="background:#ecfdf5;border:1px solid #a7f3d0;padding:10px 12px;border-radius:6px;margin-bottom:12px;color:#065f46">
            Based on this shift's observed machining time of <b>${observedMach} min</b>, the best match is:
          </div>
          <table style="width:100%;border-collapse:collapse;margin:8px 0">
            <tr><td style="padding:4px 0;color:#6b7280">Component</td><td style="text-align:right"><b>${sug.component.component_name}</b></td></tr>
            <tr><td style="padding:4px 0;color:#6b7280">Declared machining</td><td style="text-align:right"><b>${sug.machining_min} min</b></td></tr>
            <tr><td style="padding:4px 0;color:#6b7280">Match quality</td><td style="text-align:right"><b style="color:#047857">${sug.variance_pct === 0 ? 'exact match' : `${sug.variance_pct}% off`}</b></td></tr>
          </table>
          <div style="font-size:12px;color:#6b7280;margin-top:8px">
            Assigning will set <b>${machineName}</b>'s live component to <b>${sug.component.component_name}</b>.
          </div>
        </div>`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes, Assign Now',
        cancelButtonText: 'Cancel',
        confirmButtonColor: '#10b981',
        cancelButtonColor: '#6b7280',
        reverseButtons: true,
        width: 560,
      });
      if (!confirm.isConfirmed) {
        setAutoSuggestStatus({ ok: true, message: 'Cancelled.' });
        return;
      }

      const isGplast = cleanCustomerId(customerId) === window._env_.GPLAST_CUSTOMER_ID;
      const key2 = {
        component_name: sug.component.component_name,
        component_id: sug.component.component_number,
        cycle_time: sug.component.cycle_time,
        handling_time: sug.component.handling_time,
        setup_time: sug.component.setupTime,
        component_start_time: Date.now(),
        ...(isGplast && {
          item_code: sug.component.item_code,
          process_name: sug.component.process_name,
        }),
      };
      const key = {
        live_component: JSON.stringify(key2),
        lastUpdateTs: Date.now(),
      };
      await Downtimeadd1('DEVICE', selectedDeviceId.id, 'SERVER_SCOPE', key);
      setselectedcomponent(sug.component.component_name);
      setOpenEditDialog2(false);
      Swal.fire({
        title: 'Assigned',
        text: `${sug.component.component_name} is now the live component for ${machineName}.`,
        icon: 'success',
        timer: 2200,
        showConfirmButton: false,
      });
      setTimeout(() => getShifts(), 1500);
    } catch (e) {
      console.warn('auto-assign failed', e);
      setAutoSuggestStatus({ ok: false, message: 'Auto-assign failed. Check connection and try again.' });
    } finally {
      setAutoSuggestLoading(false);
    }
  };

  const openMismatchPanel = async () => {
    setMismatchOpen(true);
    setMismatchLoading(true);
    try {
      const base = (window._env_?.SERVER_URL2 || '').replace(/\/$/, '');
      const cid = cleanCustomerId(customerId);
      const [liveResp, logResp] = await Promise.all([
        fetch(`${base}/api/operator-assignment/live-cycle-mismatches?customer_id=${encodeURIComponent(cid)}`),
        fetch(`${base}/api/operator-assignment/cycle-mismatch-log-all?customer_id=${encodeURIComponent(cid)}&limit=50`),
      ]);
      if (liveResp.ok) {
        const j = await liveResp.json();
        setLiveMismatches(Array.isArray(j?.machines) ? j.machines : []);
        setMismatchShiftStartIst(j?.shift_start_ist || null);
        setMismatchSkipped(Array.isArray(j?.skipped_non_production) ? j.skipped_non_production : []);
      } else {
        setLiveMismatches([]);
        setMismatchShiftStartIst(null);
        setMismatchSkipped([]);
      }
      if (logResp.ok) {
        const j = await logResp.json();
        setMismatchEvents(Array.isArray(j?.events) ? j.events : []);
      } else {
        setMismatchEvents([]);
      }
    } catch (e) {
      console.warn('mismatch fetch failed', e);
      setLiveMismatches([]);
      setMismatchEvents([]);
    } finally {
      setMismatchLoading(false);
    }
  };

  const handleSaveThreshold2 = async () => {
    try {
      console.log('componentlist', componentslist)
      const operator = componentslist.find(op => op.component_name === componentselected);
      const component_number = operator ? operator.component_number : null;
      const cycle_time = operator ? operator.cycle_time : null;;
      const handling_time = operator ? operator.handling_time : null;
      const setupTime = operator ? operator.setupTime : null;
      const item_code = operator ? operator.item_code : null;
      const process_name = operator ? operator.process_name : null;
      const isGplast = cleanCustomerId(customerId) === window._env_.GPLAST_CUSTOMER_ID;

      // Pre-save guardrail: warn supervisor if machine's recently observed
      // cycle time is >20% off the expected cycle for the component being
      // assigned. Common cause = wrong program loaded on the machine.
      // Skipped silently when there isn't enough recent data, or if the
      // backend check fails (network etc.) — never blocks the assignment.
      try {
        const base = (window._env_?.SERVER_URL2 || '').replace(/\/$/, '');
        // Master `cycle_time` is machining-only. True per-part cycle = machining + handling.
        const expectedSec = parseHmsToSec(cycle_time) + parseHmsToSec(handling_time);
        if (base && selectedDeviceId?.id && expectedSec > 0) {
          const resp = await fetch(`${base}/api/operator-assignment/check-cycle-match`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              device_id: selectedDeviceId.id,
              expected_cycle_sec: expectedSec,
              component_id: component_number,
              component_name: componentselected,
            }),
          });
          if (resp.ok) {
            const j = await resp.json();
            if (j && j.matches === false && j.reason === 'mismatch') {
              const machineName = selectedDeviceId?.name || 'this machine';
              const html =
                `<div style="text-align:left;font-size:14px;line-height:1.5">
                  <div style="background:#fff3cd;border:1px solid #ffe69c;padding:10px 12px;border-radius:6px;margin-bottom:12px;color:#664d03">
                    <b>${machineName}</b> is currently producing parts at a different pace than this component expects.
                  </div>
                  <table style="width:100%;border-collapse:collapse;margin:8px 0">
                    <tr><td style="padding:4px 0;color:#6b7280">Expected cycle (for <b>${componentselected || ''}</b>)</td><td style="text-align:right"><b>${fmtMinSec(j.expected_cycle_sec)}</b></td></tr>
                    <tr><td style="padding:4px 0;color:#6b7280">Actual median (last ${j.lookback_hours}h, ${j.samples} parts)</td><td style="text-align:right"><b>${fmtMinSec(j.actual_median_sec)}</b></td></tr>
                    <tr><td style="padding:4px 0;color:#6b7280">Deviation</td><td style="text-align:right"><b style="color:#dc2626">${j.variance_pct}% off</b></td></tr>
                  </table>
                  <div style="font-size:12px;color:#6b7280;margin-top:8px">
                    Likely causes: wrong program loaded, different component still running, or component master cycle time needs updating.
                  </div>
                </div>`;
              const confirm = await Swal.fire({
                title: 'Cycle time mismatch',
                html,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Continue Anyway',
                cancelButtonText: 'Cancel',
                confirmButtonColor: '#ec6e17',
                cancelButtonColor: '#6b7280',
                reverseButtons: true,
                width: 520,
              });
              if (!confirm.isConfirmed) {
                setOpenEditDialog2(false);
                return;
              }
            }
          }
        }
      } catch (mismatchErr) {
        // Network/backend issue — log and continue silently. The check is a
        // safety net, not a gate.
        console.warn('cycle-mismatch check skipped:', mismatchErr);
      }

      const key2 = {
        component_name: componentselected,
        component_id: component_number,
        cycle_time,
        handling_time,
        setup_time: setupTime,
        component_start_time: Date.now(),
        ...(isGplast && {
          item_code: item_code,
          process_name: process_name,
        }),
      };
      const key = {
        live_component: JSON.stringify(key2), // Stringify the object to avoid key conflicts
        lastUpdateTs: Date.now()
      };

      // Save operator assignment logic here
      await Downtimeadd1('DEVICE', selectedDeviceId.id, 'SERVER_SCOPE', key);

      setDeviceThresholds(prev => ({
        ...prev,
        [selectedDeviceId.id || selectedDeviceId]: componentselected // Ensure unique key by using device ID
      })); Swal.fire('Success', 'Component assigned successfully.', 'success');
      setTimeout(() => {
        getShifts();
      }, 2000);
    } catch (err) {
      console.error('Update error:', err);
      Swal.fire('Error', 'Failed to assign component.', 'error');
    } finally {
      setOpenEditDialog2(false);
    }
  };
  const isOvernight = (shift) => {
    const start = dayjs(shift.start_time, 'HH:mm:ss');
    const end = dayjs(shift.end_time, 'HH:mm:ss');
    return end.isBefore(start);
  };
  const getShifts = async () => {
    try {
      const { data: allDevices = [] } = await customerbaseddevices(customerId, 100, 0);
      setDevices(allDevices);

      const thresholds = {};
      const operators = {};
      const components = {};
      let supervisors = '';
      for (const device of allDevices) {
        try {
          const response = await Deviceattributeget(device.id.id, 'downtime_threasold');
          thresholds[device.id.id || device.id] = response?.[0]?.value || null;

          // 🔽 Get operator for this device
          try {
            const key2 = 'live_operator';
            const entitytype = 'DEVICE';
            const telemetry = await telemetrylatestdata(device.id.id, entitytype, key2);

            if (telemetry?.live_operator?.[0]?.value) {
              const operator = JSON.parse(telemetry.live_operator[0].value)?.operator || '';
              operators[device.id.id] = operator;
            } else {
              operators[device.id.id] = '';
            }
          } catch (error) {
            operators[device.id.id] = '';
          }
          const key3 = 'live_component';
          const entitytype1 = 'DEVICE';

          try {
            const response = await telemetrylatestdata(device.id.id, entitytype1, key3);
            if (response && response.live_component && response.live_component.length > 0 && response.live_component[0].value) {
              let operator = JSON.parse(response.live_component[0].value).component_name;
              components[device.id.id] = operator;
            } else {
              components[device.id.id] = '';
            }
          } catch (error) {
            components[device.id.id] = '';
          }


        } catch (error) {
          console.error(`Error fetching threshold for device ${device.id}:`, error);
          thresholds[device.id.id || device.id] = null;
        }
      }
      try {
        const key4 = 'live_supervisor';
        const entitytype = 'CUSTOMER';
        const cleanCustomerId1 = cleanCustomerId(customerId)
        const telemetry = await telemetrylatestdata(cleanCustomerId1, entitytype, key4);

        if (telemetry?.live_supervisor?.[0]?.value) {
          const supervisor = JSON.parse(telemetry.live_supervisor[0].value)?.supervisor || '';
          supervisors = supervisor;
          console.log('supervisors', supervisors)
        } else {
          supervisors = '';
        }
      } catch (error) {
        supervisors = '';
      }
      setOperatorsByDevice(operators); // ✅ Store all operator names per device
      setComponentsByDevice(components);
      setSupervisorByDevice(supervisors)
    } catch (error) {
      console.error('Error fetching devices:', error);
    }
  };
  const handleOpenEditDialog4 = async () => {
    const key = 'alloperator';
    customerbasedshift(customerId, key)
      .then(async (data) => {
        const allShifts = data[0]?.value || [];
        setsupervisorslist(allShifts);
        console.log('allsupervisor', allShifts);

        // ✅ Filter only "Operator" mode
        const operatorNames = allShifts
          .filter(shift => shift.mode === "Supervisor")  // <-- filter added
          .map(shift => ({
            value: shift.operatorname,
            label: shift.operatorname
          }));

        setsupervisors(operatorNames);
        const key2 = 'live_supervisor';
        const entitytype = 'CUSTOMER';
        const cleancustomerid = cleanCustomerId(customerId);

        try {
          const response = await telemetrylatestdata(cleancustomerid, entitytype, key2);
          if (response && response.live_supervisor && response.live_supervisor.length > 0 && response.live_supervisor[0].value) {
            let operator = JSON.parse(response.live_supervisor[0].value).supervisor;
            setselectedsupervisor(operator);
          } else {
            setselectedsupervisor('');
          }
        } catch (error) {

          setselectedsupervisor('');
        }
        setOpenEditDialog4(true);
      })
      .catch(error => {
        console.error("Error fetching shifts:", error);
      });
  }
  const cancelreason = async () => {
    setOpenEditDialog1(false);
    setTimeout(() => {
      getShifts();
    }, 2000); // 2000 milliseconds = 2 seconds
  }
  const downtimereason = async () => {
    if (!selectedDeviceId.id || !selectedShift || !selectedDate) return;

    const { fromEpoch, toEpoch } = getEpochFromShift(selectedShift, selectedDate);
    if (!fromEpoch || !toEpoch) return;

    const fromTime = fromEpoch;
    const toTime = toEpoch;
    const deviceId = selectedDeviceId.id;
    try {
      if (deviceId && fromTime && toTime) {
        telemetrykeydata(deviceId, 'DEVICE', 'machineStatus', fromTime, toTime)
          .then(async machineStatusResponse => {
            const machineData = machineStatusResponse?.machineStatus || [];

            const statusMapping = {
              0: { state: "Idle", color: "#FFEB3B" },
              1: { state: "Idle", color: "#FFEB3B" },
              2: { state: "Idle", color: "#FFEB3B" },
              3: { state: "Run", color: "#4CAF50" },
              100: { state: "Disconnect", color: "#808080" },
              5: { state: "Alarm", color: "#F44336" },
            };

            let runTime = 0, idleTime = 0, disconnectTime = 0, alarmTime = 0;
            const sortedData = [...machineData].sort((a, b) => Number(a.ts) - Number(b.ts));

            for (let i = 0; i < sortedData.length; i++) {
              const currentStatus = sortedData[i].value;
              const currentTs = Number(sortedData[i].ts);

              let nextTs;
              if (i < sortedData.length - 1) {
                nextTs = Number(sortedData[i + 1].ts);
              } else {
                nextTs = Number(toTime);
              }

              const intervalStart = Math.max(currentTs, Number(fromTime));
              const intervalEnd = Math.min(nextTs, Number(toTime));
              const duration = Math.max(0, intervalEnd - intervalStart);

              if (duration > 0) {
                const state = statusMapping[currentStatus]?.state;
                if (state === "Run") {
                  runTime += duration;
                } else if (state === "Idle") {
                  idleTime += duration;
                } else if (state === "Disconnect") {
                  disconnectTime += duration;
                } else if (state === "Alarm") {
                  alarmTime += duration;
                }
              }
            }

            const msToTime = ms => {
              const absMs = Math.abs(ms);
              const hours = Math.floor(absMs / 3600000);
              const minutes = Math.floor((absMs % 3600000) / 60000);
              const seconds = Math.floor((absMs % 60000) / 1000);
              return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
            };



            const transformedData = sortedData
              .filter(item => item.ts && item.value !== undefined)
              .map(item => ({ ts: item.ts, value: item.value }));

            const extractStartEndFromOneToThree = (data) => {
              const result = [];
              let recording = false;
              let segment = { start: null, value: null };

              for (let i = 0; i < data.length; i++) {
                const current = data[i];
                const numericValue = Number(current.value);

                if (!recording && (numericValue === 0 || numericValue === 1 || numericValue === 2)) {
                  segment.start = current.ts;
                  segment.value = numericValue;
                  recording = true;
                }

                if (recording && numericValue === 3) {
                  segment.end = current.ts;
                  const startTime = new Date(segment.start);
                  const endTime = new Date(segment.end);
                  const duration = Math.floor((endTime - startTime) / 1000);

                  result.push({
                    start: segment.start,
                    end: segment.end,
                    duration: duration,
                    value: segment.value,
                    status: 'IDLE'
                  });

                  recording = false;
                  segment = { start: null, value: null };
                }

                if (recording && (numericValue === 0 || numericValue === 1 || numericValue === 2)) {
                  segment.value = numericValue;
                }
              }

              // Handle case where recording never ended (no 3 found)
              if (recording) {
                segment.end = toTime;
                const startTime = new Date(segment.start);
                const endTime = new Date(segment.end);
                const duration = Math.floor((endTime - startTime) / 1000);

                result.push({
                  start: segment.start,
                  end: segment.end,
                  duration: duration,
                  value: segment.value,
                  status: 'IDLE'
                });
              }

              return result.length > 0 ? result : [{ start: fromTime, end: toTime, duration: 0, value: 0, status: 'NO_DATA' }];
            };
            let downtime;
            const key = 'downtime_threasold';
            const results = await Deviceattributeget(deviceId, key);
            let downtimedatas = encodeURIComponent(JSON.stringify([{ start: fromTime, end: toTime, duration: 0, value: 0, status: 'NO_DATA' }]));

            if (results && results.length > 0) {
              downtime = results[0].value;
              const result = extractStartEndFromOneToThree(transformedData);
              const filteredResult = result.filter(entry => entry.duration > downtime);
              console.log('filterresult', filteredResult)
              setfilteredResult(filteredResult);
              downtimedatas = encodeURIComponent(JSON.stringify(filteredResult));
            }

            const encodedData = encodeURIComponent(JSON.stringify(transformedData));
            console.log('result', transformedData)

            return Promise.all([
              Promise.resolve(encodedData),
              Promise.resolve(downtimedatas)
            ]);
          })
          .then(async ([encodedData, downtimedatas]) => {
            const downtimedata = downtimedatas;
            console.log('downtimedata', downtimedata);

            const key2 = 'live_reason';
            const entitytype = 'DEVICE';
            const deviceid = deviceId;

            try {
              const response = await telemetrykeydata(deviceid, entitytype, key2, fromEpoch, toEpoch);

              if (
                response &&
                Array.isArray(response.live_reason) &&
                response.live_reason.length > 0
              ) {
                const parsedLiveReasons = response.live_reason.map(entry => {
                  try {
                    const parsedValue = JSON.parse(entry.value);
                    return {
                      ts: entry.ts,
                      ...parsedValue // includes: name, code, mode, module, idle_start
                    };
                  } catch (err) {
                    console.error("Failed to parse live_reason value:", entry.value, err);
                    return null;
                  }
                }).filter(reason => reason !== null);

                // For each item in filteredResult, set reasonselected if match found
                setfilteredResult(prevResults => {
                  return prevResults.map(item => {
                    const matched = parsedLiveReasons.find(reason =>
                      String(reason.ts) === String(item.start)
                    );
                    return {
                      ...item,
                      reasonselected: matched?.name || item.reasonselected || ''
                    };
                  });
                });

              } else {
                console.log("No valid live_reason data found");
              }
            } catch (error) {
              console.error("Error while processing live_reason telemetry:", error);
            }


          })


      }
    } catch (error) {
      console.error('Error fetching downtime data:', error);
    } finally {
      setLoading(false);
    }
  };
  const handleSaveThreshold3 = async () => {
    try {
      const operator = supervisors.find(op => op.operatorname === supervisorselected);
      const opertorid = operator ? operator.operatorid : null;
      const key2 = {
        "supervisor": supervisorselected,
        "supervisor_id": opertorid,
        "supervisor_start_time": Date.now()
      };
      const key = {
        live_supervisor: JSON.stringify(key2),// Stringify the object to avoid key conflicts
        lastUpdateTs: Date.now()
      };
      const cleancustomerid = cleanCustomerId(customerId);

      // Save operator assignment logic here
      await Downtimeadd2('CUSTOMER', cleancustomerid, 'SERVER_SCOPE', key);

      Swal.fire('Success', 'Supervisor assigned successfully.', 'success');
      setTimeout(() => {
        getShifts();
      }, 2000); // 2000 milliseconds = 2 seconds
    } catch (err) {
      console.error('Update error:', err);
      Swal.fire('Error', 'Failed to assign operator.', 'error');
    } finally {
      setOpenEditDialog4(false);
    }
  }
  // Convert epoch to IST date-time string
  const formatEpochToIST = (epoch) => {
    const options = { timeZone: 'Asia/Kolkata' };
    const date = new Date(epoch).toLocaleString('en-US', options);
    const d = new Date(date);

    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();

    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
    const seconds = String(d.getSeconds()).padStart(2, '0');

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };


  // Format seconds to HH:mm:ss
  const formatDuration = (durationInSeconds) => {
    const hours = Math.floor(durationInSeconds / 3600);
    const minutes = Math.floor((durationInSeconds % 3600) / 60);
    const seconds = durationInSeconds % 60;
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  };

  useEffect(() => {
    setTimeout(() => {
      getShifts();
    }, 2000);
  }, []);

  const selectedShiftData = shifts.find(shift => shift.shift_no === selectedShift);

  return (
    <div className="pages">
      <div className="pagecontents">
        <div className="left-labels">
          <div className="shift-content" style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <h5 style={{ margin: 0 }}>Allocations</h5>
            <Button
              size="small"
              variant="outlined"
              startIcon={<ReportProblemIcon style={{ color: '#dc2626' }} />}
              onClick={openMismatchPanel}
              sx={{
                borderColor: '#fecaca',
                color: '#b91c1c',
                textTransform: 'none',
                fontSize: 12,
                padding: '2px 10px',
                ':hover': { borderColor: '#fca5a5', backgroundColor: '#fef2f2' },
              }}
            >
              Recent Cycle Mismatches
            </Button>
          </div>
        </div>
        <div className="idle_reason_item">
          <div className="metric-box" style={{ fontSize: '30px', cursor: 'pointer' }} onClick={() => {
            handleOpenEditDialog4();
          }}>
            <SupervisorAccountIcon style={{ fontSize: '30px', cursor: 'pointer' }} className="metric-icon" />
            <div className="metric-content">
              <span className="metric-label">Supervisor : {supervisorsByDevice}</span>

            </div>
          </div>
        </div>&nbsp;
        <div className="idle_reason_list">
          {devices?.length > 0 ? (
            [...new Map(devices.map(device =>
              [device.id?.$oid || device.id, device])).values()]
              .sort((a, b) => (a.name || '').localeCompare(b.name || ''))
              .map((item) => {
                const itemId = item.id?.$oid || item.id;
                const threshold = deviceThresholds[item.id.id || item.id] ?? 'Not set';


                return (
                  <>
                    <div className="idle_reason_item" key={itemId} data-id={item.code}>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 12px', borderRadius: '4px' }}>
                          <span style={{ fontWeight: 600, fontSize: '20px' }}>Machine Name:</span>
                          <span style={{ color: 'black' }}>{item.name}</span>
                        </div>
                        <div style={{ display: 'flex', gap: '20px', flexDirection: 'column', }}>
                          <div className="metric-box" style={{ fontSize: '30px', cursor: 'pointer' }} onClick={(e) => {
                            e.stopPropagation();
                            handleOpenEditDialog(item);
                          }} >
                            <PersonIcon style={{ fontSize: '30px', cursor: 'pointer' }} className="metric-icon" />
                            <div className="metric-content">
                              <div className="metric-label" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px', width: '100%' }}>
                                <span>
                                  Operator: {operatorsByDevice?.[item?.id?.id] || 'N/A'}
                                </span>

                              </div>



                            </div>
                          </div>
                          <div className="metric-box" style={{ fontSize: '30px', cursor: 'pointer' }} onClick={(e) => {
                            e.stopPropagation();
                            handleOpenEditDialog1(item);
                          }}>
                            <ReportProblemIcon style={{ fontSize: '30px', cursor: 'pointer' }} className="metric-icon" />
                            <div className="metric-content">
                              <span className="metric-label">Reason</span>

                            </div>
                          </div>
                          <div className="metric-box" style={{ fontSize: '30px', cursor: 'pointer' }} onClick={(e) => {
                            e.stopPropagation();
                            handleOpenEditDialog2(item);
                          }}>
                            <SettingsIcon style={{ fontSize: '30px', cursor: 'pointer' }} className="metric-icon" />
                            <div className="metric-content">
                              {/* <span className="metric-label">Component: {componentsByDevice[item.id.id] || 'N/A'}</span> */}
                              <div className="metric-label" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <span>
                                  Component: {componentsByDevice?.[item?.id?.id] || 'N/A'}
                                </span>
                                <VisibilityIcon
                                  style={{ cursor: 'pointer', color: '#1976d2' }}
                                  onClick={(e) => {
                                    e.stopPropagation(); // Optional: prevent parent click
                                    handleViewClick1(item?.id?.id, item.name);
                                  }}
                                  titleAccess="View Component"
                                />
                              </div>

                            </div>
                          </div>

                        </div>

                      </div>
                    </div>
                  </>
                );
              })
          ) : (
            <div style={{ margin: '2rem', color: '#888' }}>No devices found.</div>
          )}
        </div>

        <Dialog
          open={openEditDialog}
          onClose={(event, reason) => {
            if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
              setOpenEditDialog(false);
            }
          }}
          disableEscapeKeyDown={true}
          sx={{
            '& .MuiDialog-paper': {
              width: '700px',
              maxWidth: '700px'
            }
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 24px 0 24px' }}>
            <DialogTitle sx={{ padding: 0 }}>Assign Operator</DialogTitle>
            <VisibilityIcon
              style={{ cursor: 'pointer', color: '#1976d2' }}
              onClick={(e) => {
                e.stopPropagation();
                handleViewClick(selectedDeviceId, selectedDevicename);
              }}
              titleAccess="View Operator"

            />
          </div>

          <DialogContent>
            <br></br>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginLeft: '10px' }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <CustomDateSelect
                  name="selectedDate"
                  label="Select Date"
                  required
                  value={selectedDate}
                  onChange={(e) => {
                    handleDateChange(e);
                    handleOperatorChange(e);
                  }}
                  format="DD-MM-YYYY"
                  minDate={dayjs()} // ✅ Allows today
                  maxDate={dayjs().add(7, 'day')} // ✅ Allows up to 7 days from today
                />
              </LocalizationProvider>
              <CustomDaySelect
                name="shift_no"
                value={selectedShift}
                onChange={(e) => {
                  const value = e.target.value;
                  handleShiftChange(value);     // First function
                  operatorvaluechange(value);       // Second function
                }}
                label="Select Shift"
                required
                options={shiftOptions}
              />
              <CustomDaySelect
                name="operatorselected"
                value={operatorselected}
                onChange={handleFormChange}
                label="Select Operator"
                required={true}
                options={operators}
                error={!operatorselected}
                ref={customDaySelectRef}
              />

            </div>
            <br></br>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginLeft: '10px' }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopTimePicker
                  value={startTime}
                  onChange={handleStartTimeChange}
                  label="Start Time"
                  minTime={
                    selectedShiftData && !isOvernight(selectedShiftData)
                      ? dayjs(selectedShiftData.start_time, 'HH:mm:ss')
                      : undefined
                  }
                  maxTime={
                    selectedShiftData && !isOvernight(selectedShiftData)
                      ? dayjs(selectedShiftData.end_time, 'HH:mm:ss')
                      : undefined
                  }
                  views={['hours', 'minutes', 'seconds']}
                  openTo="hours"
                  format="HH:mm:ss A"
                  error={!!startTime}
                  InputLabelProps={{ required: false }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': { borderColor: 'black' },
                      '&:hover fieldset': { borderColor: 'black' },
                      '&.Mui-focused fieldset': { borderColor: 'orange' },
                      '& .MuiOutlinedInput-input': { color: 'black' },
                      '&.Mui-focused .MuiOutlinedInput-input': { caretColor: 'orange' },
                      '&::placeholder': { color: 'black', opacity: 1 },
                    },
                  }}
                />
              </LocalizationProvider>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopTimePicker
                  value={endTime}
                  onChange={handleEndTimeChange}
                  label="End Time"
                  minTime={
                    selectedShiftData && !isOvernight(selectedShiftData)
                      ? dayjs(selectedShiftData.start_time, 'HH:mm:ss')
                      : undefined
                  }
                  maxTime={
                    selectedShiftData && !isOvernight(selectedShiftData)
                      ? dayjs(selectedShiftData.end_time, 'HH:mm:ss')
                      : undefined
                  }
                  views={['hours', 'minutes', 'seconds']}
                  openTo="hours"
                  format="HH:mm:ss A"
                  error={!!endTime}
                  InputLabelProps={{ required: false }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': { borderColor: 'black' },
                      '&:hover fieldset': { borderColor: 'black' },
                      '&.Mui-focused fieldset': { borderColor: 'orange' },
                      '& .MuiOutlinedInput-input': { color: 'black' },
                      '&.Mui-focused .MuiOutlinedInput-input': { caretColor: 'orange' },
                      '&::placeholder': { color: 'black', opacity: 1 },
                    },
                  }}
                />
              </LocalizationProvider>
            </div>
          </DialogContent>
          <DialogActions>
            <Button type="submit" variant="contained" className="filter_btn btn_orange" sx={{ backgroundColor: '#ff4444' }} onClick={() => setOpenEditDialog(false)}>Cancel</Button>
            <Button type="submit" variant="contained" className="filter_btn btn_orange" sx={{ backgroundColor: '#ff9800' }} onClick={handleSaveThreshold}>Save</Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openEditDialog1}
          onClose={(event, reason) => {
            if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
              setOpenEditDialog1(false);
            }
          }}
          sx={{
            '& .MuiDialog-paper': {
              width: '70%',
              maxWidth: '70%'
            }
          }}
        >
          <DialogTitle>Assign Reason</DialogTitle>
          <DialogContent>
            <br></br>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginLeft: '10px' }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <CustomDateSelect
                  name="selectedDate"
                  label="Select Date"
                  required
                  value={selectedDate}
                  onChange={handleDateChange1}
                  format="DD-MM-YYYY"
                  maxDate={dayjs()} // <-- Disallow future dates
                />
              </LocalizationProvider>
              <CustomDaySelect
                name="shift_no"
                value={selectedShift}
                onChange={(e) => handleShiftChange(e.target.value)}
                label="Select Shift"
                required
                options={shiftOptions}
              />
              <Button
                type="submit"
                variant="contained"
                className="filter_btn btn_orange" sx={{ backgroundColor: '#ff9800' }}
                onClick={() => downtimereason()}
              >
                Submit
              </Button>
            </div>
            {filteredResult.length > 0 ? (
              <div style={{ marginTop: '20px', maxHeight: '300px', overflowY: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr style={{ backgroundColor: '#f2f2f2' }}>
                      <th style={{ border: '1px solid #ccc', padding: '8px' }}>Start Time (IST)</th>
                      <th style={{ border: '1px solid #ccc', padding: '8px' }}>End Time (IST)</th>
                      <th style={{ border: '1px solid #ccc', padding: '8px' }}>Duration</th>
                      <th style={{ border: '1px solid #ccc', padding: '8px' }}>Status</th>
                      <th style={{ border: '1px solid #ccc', padding: '8px' }}>Reason</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredResult.map((item, index) => (
                      <tr key={index}>
                        <td style={{ border: '1px solid #ccc', padding: '8px' }}>{formatEpochToIST(item.start)}</td>
                        <td style={{ border: '1px solid #ccc', padding: '8px' }}>{formatEpochToIST(item.end)}</td>
                        <td style={{ border: '1px solid #ccc', padding: '8px' }}>{formatDuration(item.duration)}</td>
                        <td style={{ border: '1px solid #ccc', padding: '8px' }}>{item.status}</td>
                        <td>
                          <CustomDaySelect
                            name={`reasonselected-${index}`}
                            value={item.reasonselected || ''}
                            onChange={(e) => handleReasonChange(index, e.target.value)}
                            label="Select Reason"
                            required={true}
                            options={reasons}
                            error={!item.reasonselected}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div style={{ marginTop: '20px', textAlign: 'center', color: '#888' }}>
                <h3>No Data Found</h3>
              </div>
            )}


            {/* <CustomDaySelect
                            name="reasonselected"
                            value={reasonselected}
                            onChange={handleFormChange1}
                            label="Select Reason"
                            required={true}
                            options={reasons}
                            error={!reasonselected}
                            ref={customDaySelectRef}
                        /> */}
          </DialogContent>
          <DialogActions>
            <Button type="submit" variant="contained" className="filter_btn btn_orange" sx={{ backgroundColor: '#ff4444' }} onClick={() => cancelreason()}>Cancel</Button>
            <Button type="submit" variant="contained" className="filter_btn btn_orange" sx={{ backgroundColor: '#ff9800' }} onClick={handleSaveThreshold1}>Save</Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openEditDialog2}
          onClose={(event, reason) => {
            if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
              setOpenEditDialog2(false);
            }
          }}
          sx={{
            '& .MuiDialog-paper': {
              width: '500px',
              maxWidth: '500px'
            }
          }}
        >
          <DialogTitle>Assign Component</DialogTitle>
          <DialogContent>
            <br></br>
            {/* <CustomDaySelect
                            name="componentselected"
                            value={componentselected}
                            onChange={handleFormChange2}
                            label="Select Component"
                            required={true}
                            options={components}
                            error={!componentselected}
                            ref={customDaySelectRef}
                        /> */}
            <br></br>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginLeft: '10px' }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <CustomDateSelect
                  name="selectedDate"
                  label="Select Date"
                  required
                  value={selectedDate}
                  onChange={(e) => {
                    handleDateChange(e);
                    handleOperatorChange(e);
                  }}
                  format="DD-MM-YYYY"
                  minDate={dayjs()} // ✅ Allows today
                  maxDate={dayjs().add(7, 'day')} // ✅ Allows up to 7 days from today
                />
              </LocalizationProvider>
              <CustomDaySelect
                name="shift_no"
                value={selectedShift}
                onChange={(e) => {
                  const value = e.target.value;
                  handleShiftChange(value);     // First function
                  operatorvaluechange(value);       // Second function
                }}
                label="Select Shift"
                required
                options={shiftOptions}
              />
              <CustomDaySelect
                name="componentselected"
                value={componentselected}
                onChange={handleFormChange2}
                label="Select Component"
                required={true}
                options={components}
                error={!componentselected}
                ref={customDaySelectRef}
              />

            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginLeft: 10, marginTop: 12, flexWrap: 'wrap' }}>
              <Button
                size="small"
                variant="outlined"
                onClick={handleAutoSuggest}
                disabled={autoSuggestLoading || !selectedDeviceId?.id}
                sx={{
                  borderColor: '#10b981',
                  color: '#047857',
                  textTransform: 'none',
                  fontSize: 12,
                  fontWeight: 600,
                  padding: '4px 14px',
                  ':hover': { borderColor: '#059669', backgroundColor: '#ecfdf5' },
                }}
              >
                {autoSuggestLoading ? 'Checking…' : '🎯 Auto-Assign Best Match'}
              </Button>
              {autoSuggestStatus && (
                <span style={{
                  fontSize: 12,
                  color: autoSuggestStatus.ok ? '#047857' : '#b45309',
                  background: autoSuggestStatus.ok ? '#ecfdf5' : '#fef3c7',
                  border: `1px solid ${autoSuggestStatus.ok ? '#a7f3d0' : '#fde68a'}`,
                  padding: '4px 10px',
                  borderRadius: 6,
                  flex: 1,
                  minWidth: 0,
                }}>
                  {autoSuggestStatus.message}
                </span>
              )}
            </div>
            <br></br>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginLeft: '10px' }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopTimePicker
                  value={startTime}
                  onChange={handleStartTimeChange}
                  label="Start Time"
                  minTime={
                    selectedShiftData && !isOvernight(selectedShiftData)
                      ? dayjs(selectedShiftData.start_time, 'HH:mm:ss')
                      : undefined
                  }
                  maxTime={
                    selectedShiftData && !isOvernight(selectedShiftData)
                      ? dayjs(selectedShiftData.end_time, 'HH:mm:ss')
                      : undefined
                  }
                  views={['hours', 'minutes', 'seconds']}
                  openTo="hours"
                  format="HH:mm:ss A"
                  error={!!startTime}
                  InputLabelProps={{ required: false }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': { borderColor: 'black' },
                      '&:hover fieldset': { borderColor: 'black' },
                      '&.Mui-focused fieldset': { borderColor: 'orange' },
                      '& .MuiOutlinedInput-input': { color: 'black' },
                      '&.Mui-focused .MuiOutlinedInput-input': { caretColor: 'orange' },
                      '&::placeholder': { color: 'black', opacity: 1 },
                    },
                  }}
                />
              </LocalizationProvider>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopTimePicker
                  value={endTime}
                  onChange={handleEndTimeChange}
                  label="End Time"
                  minTime={
                    selectedShiftData && !isOvernight(selectedShiftData)
                      ? dayjs(selectedShiftData.start_time, 'HH:mm:ss')
                      : undefined
                  }
                  maxTime={
                    selectedShiftData && !isOvernight(selectedShiftData)
                      ? dayjs(selectedShiftData.end_time, 'HH:mm:ss')
                      : undefined
                  }
                  views={['hours', 'minutes', 'seconds']}
                  openTo="hours"
                  format="HH:mm:ss A"
                  error={!!endTime}
                  InputLabelProps={{ required: false }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': { borderColor: 'black' },
                      '&:hover fieldset': { borderColor: 'black' },
                      '&.Mui-focused fieldset': { borderColor: 'orange' },
                      '& .MuiOutlinedInput-input': { color: 'black' },
                      '&.Mui-focused .MuiOutlinedInput-input': { caretColor: 'orange' },
                      '&::placeholder': { color: 'black', opacity: 1 },
                    },
                  }}
                />
              </LocalizationProvider>
            </div>
          </DialogContent>
          <DialogActions>
            <Button type="submit" variant="contained" className="filter_btn btn_orange" sx={{ backgroundColor: '#ff4444' }} onClick={() => setOpenEditDialog2(false)}>Cancel</Button>
            <Button type="submit" variant="contained" className="filter_btn btn_orange" sx={{ backgroundColor: '#ff9800' }} onClick={handleSaveThreshold2}>Save</Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={OpenEditDialog4}
          onClose={() => setOpenEditDialog4(false)}

          disableEscapeKeyDown={true}
          sx={{
            '& .MuiDialog-paper': {
              width: '500px',
              maxWidth: '500px'
            }
          }}
        >
          <DialogTitle>Assign Supervisor</DialogTitle>
          <DialogContent>
            <CustomDaySelect
              name="supervisorselected"
              value={supervisorselected}
              onChange={handleFormChange3}
              label="Select Supervisor"
              required={true}
              options={supervisors}
              error={!supervisorselected}
              ref={selectRef}
            />
          </DialogContent>
          <DialogActions>
            <Button type="submit" variant="contained" className="filter_btn btn_orange" sx={{ backgroundColor: '#ff4444' }} onClick={() => setOpenEditDialog4(false)}>Cancel</Button>
            <Button type="submit" variant="contained" className="filter_btn btn_orange" sx={{ backgroundColor: '#ff9800' }} onClick={handleSaveThreshold3}>Save</Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={mismatchOpen}
          onClose={() => setMismatchOpen(false)}
          maxWidth="md"
          fullWidth
          sx={{ '& .MuiDialog-paper': { borderRadius: '10px' } }}
        >
          <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, paddingBottom: '8px' }}>
            <ReportProblemIcon style={{ color: '#dc2626' }} />
            <span style={{ fontSize: 17, fontWeight: 600 }}>Recent Cycle Mismatches</span>
            <span style={{ marginLeft: 'auto', fontSize: 12, color: '#6b7280', fontWeight: 400 }}>
              Last {mismatchEvents.length} events (newest first)
            </span>
          </DialogTitle>
          <DialogContent dividers sx={{ padding: 0 }}>
            {mismatchLoading ? (
              <div style={{ padding: 24, textAlign: 'center', color: '#6b7280' }}>Loading…</div>
            ) : (liveMismatches.length === 0 && mismatchEvents.length === 0 && mismatchSkipped.length === 0) ? (
              <div style={{ padding: 40, textAlign: 'center', color: '#6b7280' }}>
                <div style={{ fontSize: 32, marginBottom: 8 }}>✓</div>
                <div style={{ fontSize: 14 }}>All machines are running within tolerance.</div>
                <div style={{ fontSize: 12, marginTop: 6, color: '#9ca3af' }}>
                  Mismatches appear here when a machine's actual cycle time differs from
                  its assigned component's expected cycle time by more than 20%.
                </div>
              </div>
            ) : (
              <div>
                {/* LIVE DETECTED — currently happening across the floor */}
                <div style={{ padding: '12px 16px 6px 16px', background: '#fff7ed', borderBottom: '1px solid #fed7aa' }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: '#9a3412', display: 'flex', alignItems: 'center', gap: 6 }}>
                    <span style={{ display: 'inline-block', width: 8, height: 8, borderRadius: '50%', background: '#dc2626' }}></span>
                    Live — Detected Right Now
                    <span style={{ marginLeft: 'auto', fontSize: 11, color: '#6b7280', fontWeight: 400 }}>
                      {liveMismatches.length} {liveMismatches.length === 1 ? 'machine' : 'machines'} off-target
                    </span>
                  </div>
                  <div style={{ fontSize: 11, color: '#9a3412', marginTop: 2 }}>
                    Machines whose machining or handling differs from declared by &gt;20%, this shift only
                    {mismatchShiftStartIst && (
                      <span style={{ color: '#6b7280', marginLeft: 6 }}>
                        · Shift started {mismatchShiftStartIst}
                      </span>
                    )}
                  </div>
                </div>
                {liveMismatches.length === 0 ? (
                  <div style={{ padding: 16, fontSize: 13, color: '#6b7280', textAlign: 'center' }}>
                    No active mismatches detected.
                  </div>
                ) : (() => {
                  const toggleSort = (col) => {
                    setMismatchSort((s) => s.col === col
                      ? { col, dir: s.dir === 'desc' ? 'asc' : 'desc' }
                      : { col, dir: 'desc' }
                    );
                  };
                  const arrow = (col) => mismatchSort.col === col
                    ? (mismatchSort.dir === 'desc' ? ' ▼' : ' ▲')
                    : '';
                  const sortVal = (m, col) => {
                    if (col === 'device_name') return (m.device_name || '').toLowerCase();
                    const v = m[col];
                    return v == null ? -1 : v;
                  };
                  const sortedList = [...liveMismatches].sort((a, b) => {
                    const va = sortVal(a, mismatchSort.col);
                    const vb = sortVal(b, mismatchSort.col);
                    if (va < vb) return mismatchSort.dir === 'desc' ? 1 : -1;
                    if (va > vb) return mismatchSort.dir === 'desc' ? -1 : 1;
                    return 0;
                  });
                  const headerStyle = {
                    padding: '8px 14px',
                    borderBottom: '1px solid var(--y-border, #e5e7eb)',
                    fontWeight: 600,
                    cursor: 'pointer',
                    userSelect: 'none',
                  };
                  return (
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                    <thead>
                      <tr style={{ background: 'var(--y-bg-soft, #fafafa)', color: '#374151', textAlign: 'left' }}>
                        <th style={headerStyle} onClick={() => toggleSort('device_name')}>Machine{arrow('device_name')}</th>
                        <th style={{ padding: '8px 14px', borderBottom: '1px solid var(--y-border, #e5e7eb)', fontWeight: 600 }}>Currently assigned</th>
                        <th style={{ ...headerStyle, textAlign: 'center' }} onClick={() => toggleSort('machining_variance_pct')} title="Machining time identifies the program — operator-independent. Click to sort.">Machining{arrow('machining_variance_pct')}<br/><span style={{ fontSize: 10, color: '#9ca3af', fontWeight: 400 }}>(program signal)</span></th>
                        <th style={{ ...headerStyle, textAlign: 'center' }} onClick={() => toggleSort('handling_variance_pct')} title="Handling time depends on operator speed. Click to sort.">Handling{arrow('handling_variance_pct')}<br/><span style={{ fontSize: 10, color: '#9ca3af', fontWeight: 400 }}>(operator signal)</span></th>
                        <th style={{ padding: '8px 14px', borderBottom: '1px solid var(--y-border, #e5e7eb)', fontWeight: 600 }}>Suggested fix</th>
                      </tr>
                    </thead>
                    <tbody>
                      {sortedList.map((m, i) => {
                        const sug = findSuggestedComponent(m.observed_machining_min);
                        const cellStyle = (off) => ({
                          padding: '10px 14px',
                          textAlign: 'center',
                          background: off ? '#fef2f2' : '#ecfdf5',
                        });
                        return (
                          <tr key={`live-${i}`} style={{ borderBottom: '1px solid #f3f4f6' }}>
                            <td style={{ padding: '10px 14px', color: '#111827', fontWeight: 500 }}>
                              <div>{m.device_name}</div>
                              <div style={{ fontSize: 10, color: '#6b7280', marginTop: 2 }}>
                                {m.current_status || ''}{m.parts_produced != null ? ` · ${m.parts_produced}/${m.target_parts ?? '?'} parts` : ''}
                              </div>
                            </td>
                            <td style={{ padding: '10px 14px', color: '#374151' }}>{m.component_name || m.component_code || '-'}</td>
                            <td style={cellStyle(m.machining_off)}>
                              <div style={{ fontSize: 12, color: m.machining_off ? '#b91c1c' : '#065f46', fontWeight: 600 }}>
                                {m.observed_machining_min != null ? `${m.observed_machining_min}m` : 'no data'}
                              </div>
                              <div style={{ fontSize: 10, color: '#6b7280', marginTop: 2 }}>
                                vs declared {m.declared_machining_min}m
                              </div>
                              {m.machining_variance_pct != null && (
                                <div style={{ fontSize: 10, color: m.machining_off ? '#b91c1c' : '#047857', fontWeight: 600, marginTop: 1 }}>
                                  {m.machining_off
                                    ? `${m.machining_variance_pct}% ${m.machining_direction === 'slower' ? '▲ slower' : '▼ faster'}`
                                    : `match (${m.machining_variance_pct}%)`}
                                </div>
                              )}
                            </td>
                            <td style={cellStyle(m.handling_off)}>
                              <div style={{ fontSize: 12, color: m.handling_off ? '#b91c1c' : '#065f46', fontWeight: 600 }}>
                                {m.observed_handling_min != null ? `${m.observed_handling_min}m` : 'no data'}
                              </div>
                              <div style={{ fontSize: 10, color: '#6b7280', marginTop: 2 }}>
                                vs declared {m.declared_handling_min}m
                              </div>
                              {m.handling_variance_pct != null && (
                                <div style={{ fontSize: 10, color: m.handling_off ? '#b91c1c' : '#047857', fontWeight: 600, marginTop: 1 }}>
                                  {m.handling_off
                                    ? `${m.handling_variance_pct}% ${m.handling_direction === 'slower' ? '▲ slower' : '▼ faster'}`
                                    : `ok (${m.handling_variance_pct}%)`}
                                </div>
                              )}
                            </td>
                            <td style={{ padding: '8px 14px' }}>
                              {!m.machining_off ? (
                                <span style={{ fontSize: 11, color: '#047857', fontStyle: 'italic' }}>
                                  Program is correct — handling issue
                                </span>
                              ) : sug ? (
                                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                  <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0, flex: 1 }}>
                                    <div title={sug.component.component_name} style={{
                                      fontSize: 12,
                                      color: '#065f46',
                                      fontWeight: 500,
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                      maxWidth: 180,
                                    }}>
                                      🎯 {sug.component.component_name}
                                    </div>
                                    <div style={{ fontSize: 11, color: '#6b7280' }}>
                                      machining {sug.machining_min}m · {sug.variance_pct === 0 ? 'exact match' : `${sug.variance_pct}% off`}
                                    </div>
                                  </div>
                                  <Button
                                    size="small"
                                    variant="contained"
                                    onClick={() => assignSuggestedFromPanel(m.device_id, m.device_name, sug.component)}
                                    sx={{
                                      backgroundColor: '#10b981',
                                      color: '#fff',
                                      textTransform: 'none',
                                      fontSize: 11,
                                      padding: '3px 10px',
                                      minWidth: 0,
                                      ':hover': { backgroundColor: '#059669' },
                                    }}
                                  >
                                    Assign
                                  </Button>
                                </div>
                              ) : (
                                <span style={{ fontSize: 11, color: '#9ca3af', fontStyle: 'italic' }}>
                                  No matching machining time in master
                                </span>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  );
                })()}

                {/* NOT IN PRODUCTION — machines deliberately skipped from mismatch detection */}
                {mismatchSkipped.length > 0 && (() => {
                  const statusPill = (status) => {
                    const colors = {
                      Running:      { bg: '#dcfce7', fg: '#166534' },
                      Idle:         { bg: '#fef3c7', fg: '#854d0e' },
                      Alarm:        { bg: '#fee2e2', fg: '#991b1b' },
                      Setting:      { bg: '#e0e7ff', fg: '#3730a3' },
                      Locked:       { bg: '#f3e8ff', fg: '#6b21a8' },
                      Disconnected: { bg: '#f3f4f6', fg: '#6b7280' },
                    };
                    const c = colors[status] || colors.Disconnected;
                    return (
                      <span style={{
                        background: c.bg, color: c.fg, padding: '2px 8px',
                        borderRadius: 999, fontSize: 11, fontWeight: 600,
                        display: 'inline-block', whiteSpace: 'nowrap',
                      }}>{status}</span>
                    );
                  };
                  return (
                  <>
                    <div style={{ padding: '12px 16px 6px 16px', background: '#eff6ff', borderTop: '1px solid #e5e7eb', borderBottom: '1px solid #bfdbfe' }}>
                      <div style={{ fontSize: 13, fontWeight: 600, color: '#1e40af', display: 'flex', alignItems: 'center', gap: 6 }}>
                        ⏸ Not in Production — Skipped
                        <span style={{ marginLeft: 'auto', fontSize: 11, color: '#6b7280', fontWeight: 400 }}>
                          {mismatchSkipped.length} {mismatchSkipped.length === 1 ? 'machine' : 'machines'}
                        </span>
                      </div>
                      <div style={{ fontSize: 11, color: '#1e3a8a', marginTop: 2 }}>
                        Excluded because of alarm, setup, idle reason, or insufficient parts produced this shift
                      </div>
                    </div>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                      <thead>
                        <tr style={{ background: 'var(--y-bg-soft, #fafafa)', color: '#374151', textAlign: 'left' }}>
                          <th style={{ padding: '8px 14px', borderBottom: '1px solid var(--y-border, #e5e7eb)', fontWeight: 600 }}>Machine</th>
                          <th style={{ padding: '8px 14px', borderBottom: '1px solid var(--y-border, #e5e7eb)', fontWeight: 600 }}>Status</th>
                          <th style={{ padding: '8px 14px', borderBottom: '1px solid var(--y-border, #e5e7eb)', fontWeight: 600 }}>Currently assigned</th>
                          <th style={{ padding: '8px 14px', borderBottom: '1px solid var(--y-border, #e5e7eb)', fontWeight: 600, textAlign: 'right' }}>Parts / Target</th>
                          <th style={{ padding: '8px 14px', borderBottom: '1px solid var(--y-border, #e5e7eb)', fontWeight: 600 }}>Why skipped</th>
                        </tr>
                      </thead>
                      <tbody>
                        {mismatchSkipped.map((s, i) => (
                          <tr key={`skip-${i}`} style={{ borderBottom: '1px solid #f3f4f6' }}>
                            <td style={{ padding: '10px 14px', color: '#111827', fontWeight: 500 }}>{s.device_name}</td>
                            <td style={{ padding: '10px 14px' }}>{statusPill(s.current_status)}</td>
                            <td style={{ padding: '10px 14px', color: '#374151' }}>{s.component_name || '-'}</td>
                            <td style={{ padding: '10px 14px', color: '#374151', textAlign: 'right' }}>
                              <b>{s.parts_produced}</b>
                              <span style={{ color: '#9ca3af' }}> / {s.target_parts ?? '-'}</span>
                            </td>
                            <td style={{ padding: '10px 14px', color: '#1e40af', fontSize: 12 }}>{s.reason}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </>
                  );
                })()}

                {/* ASSIGNMENT HISTORY — past warnings supervisors confirmed */}
                <div style={{ padding: '12px 16px 6px 16px', background: 'var(--y-bg-soft, #f9fafb)', borderTop: '1px solid #e5e7eb', borderBottom: '1px solid var(--y-border, #e5e7eb)' }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: '#374151', display: 'flex', alignItems: 'center', gap: 6 }}>
                    📋 Assignment History
                    <span style={{ marginLeft: 'auto', fontSize: 11, color: '#6b7280', fontWeight: 400 }}>
                      {mismatchEvents.length} past {mismatchEvents.length === 1 ? 'event' : 'events'}
                    </span>
                  </div>
                  <div style={{ fontSize: 11, color: '#6b7280', marginTop: 2 }}>
                    Times a supervisor clicked "Continue Anyway" on the mismatch warning while assigning a component
                  </div>
                </div>
                {mismatchEvents.length === 0 ? (
                  <div style={{ padding: 16, fontSize: 13, color: '#6b7280', textAlign: 'center' }}>
                    No assignment-time warnings recorded yet.
                  </div>
                ) : (
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                    <thead>
                      <tr style={{ background: 'var(--y-bg-soft, #fafafa)', color: '#374151', textAlign: 'left' }}>
                        <th style={{ padding: '8px 14px', borderBottom: '1px solid var(--y-border, #e5e7eb)', fontWeight: 600 }}>When (IST)</th>
                        <th style={{ padding: '8px 14px', borderBottom: '1px solid var(--y-border, #e5e7eb)', fontWeight: 600 }}>Machine</th>
                        <th style={{ padding: '8px 14px', borderBottom: '1px solid var(--y-border, #e5e7eb)', fontWeight: 600 }}>Component</th>
                        <th style={{ padding: '8px 14px', borderBottom: '1px solid var(--y-border, #e5e7eb)', fontWeight: 600, textAlign: 'right' }}>Expected</th>
                        <th style={{ padding: '8px 14px', borderBottom: '1px solid var(--y-border, #e5e7eb)', fontWeight: 600, textAlign: 'right' }}>Actual</th>
                        <th style={{ padding: '8px 14px', borderBottom: '1px solid var(--y-border, #e5e7eb)', fontWeight: 600, textAlign: 'right' }}>Off by</th>
                      </tr>
                    </thead>
                    <tbody>
                      {mismatchEvents.map((ev, i) => (
                        <tr key={`log-${i}`} style={{ borderBottom: '1px solid #f3f4f6' }}>
                          <td style={{ padding: '10px 14px', color: '#374151', whiteSpace: 'nowrap' }}>{ev.ts_ist || '-'}</td>
                          <td style={{ padding: '10px 14px', color: '#111827', fontWeight: 500 }}>{ev.device_name || ev.device_id?.slice(0, 8)}</td>
                          <td style={{ padding: '10px 14px', color: '#374151' }}>{ev.component_name || ev.component_id || '-'}</td>
                          <td style={{ padding: '10px 14px', color: '#374151', textAlign: 'right' }}>{fmtMinSec(ev.expected_sec)}</td>
                          <td style={{ padding: '10px 14px', color: '#374151', textAlign: 'right' }}>{fmtMinSec(ev.actual_median_sec)}</td>
                          <td style={{ padding: '10px 14px', textAlign: 'right' }}>
                            <span style={{
                              background: '#fef2f2',
                              color: '#b91c1c',
                              padding: '2px 8px',
                              borderRadius: 999,
                              fontSize: 12,
                              fontWeight: 600,
                            }}>{ev.variance_pct}%</span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            )}
          </DialogContent>
          <DialogActions sx={{ padding: '10px 16px' }}>
            <Button onClick={openMismatchPanel} sx={{ textTransform: 'none' }}>Refresh</Button>
            <Button onClick={() => setMismatchOpen(false)} variant="contained" sx={{ textTransform: 'none', backgroundColor: '#ec6e17', ':hover': { backgroundColor: '#d35a0c' } }}>Close</Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
};

export default Allocation;